import Openable from './openable';

class Modal extends Openable {
  constructor(element, overlay, context) {
    super(element, overlay, context);

    this.classes = {
      ...this.classes,
      active: 'modal--active',
    };
  }
}

export default (element, overlay, context) => new Modal(element, overlay, context);
